import * as React from 'react';
import { ComplexValue, ValidationProps, AccessCard } from 'ui';
import { OptionsProps } from 'app/components/options-handler';
import { LoadOptions } from 'app/types-shared';
import { mapValidation, mapInvalidOptions } from '../shared';
import { sortByDescriptionAscending } from 'app/infrastructure/data/sort';

export interface OptionCardProps extends OptionsProps {

  groupId: number;
  label: string;
  valueItems: ComplexValue<number>[];
  initialValueItems: ComplexValue<number>[];

  formName: string;
  groupingName: string;
  valueName: string;

  validation: { [key: string]: ValidationProps };
  readOnly: boolean;
  translation: any;

  valuesOptionsEndpoint: (groupId: number) => string;
  useLabelOption: boolean;

  addGroup: () => void;
  removeGroup: (groupId: number) => void;
  onChange: (values: ComplexValue<number>[], groupId: number) => void;
}

const cardName = (formName: string, groupId: number) => formName + '-' + groupId;
const emptyOptions = { codes: [], fetching: true };

export class OptionCard extends React.Component<OptionCardProps> {

  private removeGroup = () => {
    this.props.removeGroup(this.props.groupId);
  };

  private onChange = (values: ComplexValue<number>[]) => {
    this.props.onChange(values, this.props.groupId);
  };

  private onLoadOptions = (opt: LoadOptions) => {

    const { formName, groupId, valuesOptionsEndpoint, loadOptions } = this.props;

    loadOptions(cardName(formName, groupId), valuesOptionsEndpoint(groupId), {});
  };

  public render() {

    const { groupId, label, valueItems, initialValueItems, formName, groupingName, valueName,
      validation, options, useLabelOption, translation, readOnly, children } = this.props;

    const cardValidation = mapValidation(validation, groupId, formName, groupingName);
    const invalidOptions = mapInvalidOptions(cardValidation, valueName);
    const option = options[cardName(formName, groupId)] || emptyOptions;

    return <AccessCard
      componentId={cardName(formName, groupId)}
      className={undefined}
      label={{ text: label }}
      valueItems={valueItems}
      initialValueItems={initialValueItems}
      invalidOptions={invalidOptions}
      options={sortByDescriptionAscending(useLabelOption ? valueItems : option.codes)}
      onLoadOptions={this.onLoadOptions}
      fetching={useLabelOption ? false : option.fetching}
      validation={cardValidation}
      removeLabel={translation.remove}
      onChange={this.onChange}
      onDelete={this.removeGroup}
      useLabelOption={useLabelOption}
      readOnly={readOnly}
      readOnlyLabel={readOnly ? translation.access_card_settings_to_selected_roles : undefined}>
      {children}
    </AccessCard>;
  }
}
